import React, { useState } from "react";
import { Copy, Check, Terminal, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const SERVER_IP = "connect cfx.re/join/forzapilots";
const DISCORD = "https://discord.gg/placeholder";

export default function Connect() {
    const [copied, setCopied] = useState(false);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(SERVER_IP);
            setCopied(true);
            toast.success("// IP COPIADO. Acelera!");
            setTimeout(() => setCopied(false), 2000);
        } catch (e) {
            toast.error("Erro ao copiar");
        }
    };

    return (
        <section
            id="conectar"
            data-testid="connect-section"
            className="relative py-24 md:py-40 bg-[#0a0a0a] overflow-hidden"
        >
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] glow-yellow pointer-events-none" />

            <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative">
                <div className="text-center mb-12">
                    <div className="inline-flex items-center gap-3 mb-4 justify-center">
                        <span className="h-px w-12 bg-neon-yellow" />
                        <span className="font-mono text-xs uppercase tracking-[0.3em] text-neon-yellow">
                            ▸ Conexão direta
                        </span>
                        <span className="h-px w-12 bg-neon-yellow" />
                    </div>
                    <h2 className="font-heading text-6xl md:text-8xl uppercase tracking-tighter leading-[0.85]">
                        Liga o motor.
                        <br />
                        <span className="text-neon-yellow">Bem-vindo.</span>
                    </h2>
                </div>

                {/* Connect terminal block */}
                <div className="max-w-4xl mx-auto bg-black border-2 border-neon-yellow shadow-brutal">
                    <div className="flex items-center justify-between border-b border-neon-yellow/30 px-5 py-3">
                        <div className="flex items-center gap-2">
                            <Terminal size={14} className="text-neon-yellow" />
                            <span className="font-mono text-xs text-white/60 uppercase tracking-[0.2em]">
                                forza_pilots.connect
                            </span>
                        </div>
                        <span className="font-mono text-[10px] text-neon-yellow flicker">
                            ● LIVE
                        </span>
                    </div>

                    <div className="p-8 md:p-12">
                        <div className="font-mono text-xs text-white/50 mb-4">
                            $ &gt; Abra o FiveM e cole o endereço abaixo:
                        </div>
                        <div className="flex flex-col md:flex-row items-stretch gap-3">
                            <code
                                data-testid="server-ip"
                                className="flex-1 bg-[#141414] border border-white/10 px-5 py-5 font-mono text-base md:text-2xl text-neon-yellow break-all"
                            >
                                {SERVER_IP}
                            </code>
                            <button
                                onClick={copy}
                                data-testid="copy-ip-button"
                                className="bg-neon-yellow text-black font-heading text-xl uppercase px-7 py-4 hover:bg-white transition-colors inline-flex items-center justify-center gap-3"
                            >
                                {copied ? (
                                    <>
                                        <Check size={20} /> Copiado
                                    </>
                                ) : (
                                    <>
                                        <Copy size={20} /> Copiar IP
                                    </>
                                )}
                            </button>
                        </div>

                        <div className="mt-8 grid sm:grid-cols-3 gap-3 font-mono text-xs">
                            <div className="border border-white/10 p-3">
                                <div className="text-white/40 uppercase mb-1">
                                    Slots
                                </div>
                                <div className="text-neon-yellow text-lg">
                                    128 / 128
                                </div>
                            </div>
                            <div className="border border-white/10 p-3">
                                <div className="text-white/40 uppercase mb-1">
                                    Ping BR
                                </div>
                                <div className="text-neon-yellow text-lg">
                                    98ms
                                </div>
                            </div>
                            <div className="border border-white/10 p-3">
                                <div className="text-white/40 uppercase mb-1">
                                    Status
                                </div>
                                <div className="text-neon-yellow text-lg">
                                    ONLINE
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <a
                        href={DISCORD}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="connect-discord-btn"
                        className="bg-transparent border-2 border-white text-white font-heading text-xl uppercase px-7 py-4 hover:bg-white hover:text-black transition-colors inline-flex items-center gap-3"
                    >
                        Entrar no Discord
                        <ArrowRight size={20} />
                    </a>
                    <span className="font-mono text-xs text-white/40 uppercase tracking-[0.2em]">
                        ou cola lá pra colar com a crew
                    </span>
                </div>
            </div>
        </section>
    );
}
